import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import SelectAsync from 'react-select/async';
import DatePicker from 'react-datepicker2';
//https://s-yadav.github.io/react-number-format/docs/numeric_format/
import NumberFormat from 'react-number-format';
import Person from "../Person";
import Receipt from "./Receipt";
import Invoice from "../Tax/Invoice";
import SendPayLink from '../SendPayLink';
import PracticalTexts from "../PracticalTexts";
import WorkFlowStepLogging from "../BPMS/WorkFlowStepLogging";

export default class Factor extends Base {
	constructor(props) {
		super(props);
		this.state = {
			enableDatePicker: false,
			confirmBeforeEsacpe: true,
			caller: props.Caller,
			controllerName: 'factor',
			refreshCallerAfterSave: this.isNull(props.RefreshCallerAfterSave) ? true : props.RefreshCallerAfterSave,
			id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
			orderingId: this.isNull(props.OrderingId) ? this.defaultGuid() : props.OrderingId,
			type: props.Type,
			data: null,
			loading: true,
			barcode: '',
			lastAdjustmentTextId: null,
			uiSettings: this.getUiSettings(),
			highlightedStuffs: this.isNull(props.HighlightedStuffs) ? [] : props.HighlightedStuffs,
			pricesAnnouncements: [],
			nutrition: null,
			nutritionWarehouse: null,
			nutritionAmount: 0,
			nutritionVersion: this.uuidv4()
		};
		this.inputRefs = [];
		this.keyDownFunction = this.keyDownFunction.bind(this);
	}
	openPrint() {
		this.showComponents({
			component: <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
				<div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closePopupComponent()}></div>
				<div className="modal-dialog ui-draggable" style={{ "minWidth": "60%" }}>
					<div className="modal-content">
						<div className="modal-body" style={{ "padding": "0" }}>
							<div className="modal-header modal-header-info">
								<button type="button" className="close" onClick={e => this.closePopupComponent()} aria-label="Close"><span aria-hidden="true">×</span></button>
								<h4 className="modal-title">چاپ</h4>
							</div>
							<div className="modal-body">
								<div className="container-fluid">
									<div className="row">
										<div className="col-sm-12 mb-2">
											<div className="form-group">
												<label for="name" className="title1">عنوان</label><span className="red">*</span>
												<select defaultValue={this.state.printFormat} onChange={e => this.state.printFormat = e.target.value} className="form-control">
													<option value="">استاندارد A4</option>
													<option value="DetailA5">استاندارد A5</option>
												</select>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="modal-footer">
								<button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closePopupComponent()}>برگشت</button>
								<button type="submit" onClick={e => this.getPdf(this.state.data.record.id, { type: this.state.data.record.type })} className="btn btn-success">PDF</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		});
	}
	resetRefs() {
		this.inputRefs = [];
	}
	handleKeyDown = (rowIndex, colIndex, e) => {
		const row = this.inputRefs[rowIndex];
		const colCount = row.length;
		const rowCount = this.inputRefs.length;

		if (colCount <= colIndex && rowCount <= rowIndex) return;

		if (e.key === "Enter") {
			e.preventDefault();
			if (colIndex + 1 < colCount) {
				//find first next active input
				if (!row[colIndex + 1]) {
					this.handleKeyDown(rowIndex, colIndex + 1, e);
				}
				else {
					row[colIndex + 1]?.focus();
					if (row[colIndex + 1]?.type === "text") row[colIndex + 1]?.select();
				}
			} else if (rowIndex + 1 < rowCount) {
				if (!this.inputRefs[rowIndex + 1][0]) {
					this.handleKeyDown(rowIndex + 1, 1, e);
				}
				else {
					this.inputRefs[rowIndex + 1][0]?.focus();
					if (this.inputRefs[rowIndex + 1][0]?.type === "text") this.inputRefs[rowIndex + 1][0]?.select();
				}
			}
		}

		if (e.key === "ArrowDown") {
			e.preventDefault();
			e.preventDefault();
			if (rowIndex + 1 < rowCount) {
				this.inputRefs[rowIndex + 1][colIndex]?.focus();
				if (this.inputRefs[rowIndex + 1][colIndex]?.type === "text") this.inputRefs[rowIndex + 1][colIndex]?.select();
			}
		}

		if (e.key === "ArrowUp") {
			e.preventDefault();
			if (rowIndex - 1 >= 0) {
				this.inputRefs[rowIndex - 1][colIndex]?.focus();
				if (this.inputRefs[rowIndex - 1][colIndex]?.type === "text") this.inputRefs[rowIndex - 1][colIndex]?.select();
			}
		}
	}
	componentWillUnmount() {
		this.removeKeyDown();
	}
	componentDidMount() {
		this.addKeyDown();

		this.getUiSettingConfigs({ formName: 'factor' });

		this.httpPost("api/v1/factor/get", {
			id: this.state.id,
			type: this.state.type,
			orderingId: this.state.orderingId,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					window.organizationId = data.global.company.id;
					this.state.data = data;

					for (var i = 0; i < this.state.data.bodies.length; i++)
						this.updateRealTimeInventory(this.state.data.bodies[i]);

					this.state.loading = false;
					this.updateFormula();

					if (!this.isEmpty(this.state.highlightedStuffs)) {
						var highlightedRowTimer = setInterval(() => {
							clearInterval(highlightedRowTimer);
							var t = document.getElementById('highlightedStuffs_' + this.state.highlightedStuffs[0]);
							if (t) {
								t.scrollIntoView({
									behavior: 'smooth',
									block: 'start',
									inline: 'nearest',
								});
							}
						}, 500);
					}

				}
				else {
					//this.showErorrMessage(data.message);
					this.setState({
						data: data,
						loading: false
					});
				}
			});
	}
	selectTextAddjustment(type, id) {
		this.state.lastAdjustmentTextId = id;
		this.removeKeyDown();
		this.showComponents({
			component: <PracticalTexts
				Caller={this}
				Type={type}
				OnSelect="onSelectTextAddjustment"
			/>
		});
	}
	onSelectTextAddjustment(e) {
		this.state.data.adjustments.forEach(adj => {
			if (adj.id === this.state.lastAdjustmentTextId) {
				adj.description = e.text;
			}
		});
		this.setState({ data: this.state.data });
	}
	onSendPayLink() {
		this.removeKeyDown();
		this.showComponents({
			component: <SendPayLink Caller={this} Source={1} SourceId={this.state.data.record.id} OrganizationId={this.state.data.global.company.id} />
		});
	}
	save(e, status) {
		e.preventDefault();
		if (this.isBlank(this.state.data.record.number)) this.state.data.record.number = 0;
		if (this.isBlank(this.state.data.record.discount)) this.state.data.record.discount = 0;
		if (this.isBlank(this.state.data.record.discountPercent)) this.state.data.record.discountPercent = 0;
		if (this.isBlank(this.state.data.record.expireDuration)) this.state.data.record.expireDuration = 0;

		this.httpPost("api/v1/factor/save", {
			id: this.state.id,
			organizationId: this.state.data.global.company.id,
			orderingId: this.state.data.record.orderingId,
			expireDuration: this.state.data.record.expireDuration,
			personMoeinAccountId: this.state.data.record.personMoeinAccountId,
			personId: this.state.data.record.personId,
			number: this.state.data.record.number,
			date: (this.state.enableDatePicker === true ? this.convertMomentToDb(this.state.data.record.date) : this.state.data.record.dateString),
			dueDate: this.convertMomentToDb(this.state.data.record.dueDate),
			discount: this.state.data.record.discount,
			tprdis: this.state.data.record.tprdis,
			tdis: this.state.data.record.tdis,
			tvam: this.state.data.record.tvam,
			total: this.state.data.record.total,
			description: this.state.data.record.description,
			discountPercent: this.state.data.record.discountPercent,
			note: this.state.data.record.note,
			status,
			type: this.state.data.record.type,
			manualRemittance: this.state.data.record.manualRemittance,

			restaurantTableId: this.state.data.record.restaurantTableId,
			takeOut: this.state.data.record.takeOut,
			courierId: this.state.data.record.courierId,
			address: this.state.data.record.address,

			bodies: this.state.data.bodies,
			adjustments: this.state.data.adjustments,

			tprdis2: this.state.data.record.tprdis2,
			tdis2: this.state.data.record.tdis2,
			tvam2: this.state.data.record.tvam2,
			total2: this.state.data.record.total2,
			type2Id: this.state.data.record.type2Id,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					this.showSuccessMessage("فاکتور با موفقیت ذخیره شد");

					if (this.state.refreshCallerAfterSave)
						this.state.caller.refreshData(null, "list", "json", (this.state.id === this.getDefaultGuid() ? true : false));

					this.closeMe();
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	documentGenerate() {
		this.httpPost('api/v1/factor/documentgenerate', {
			type: this.state.data.record.type,
			fromDate: '',
			toDate: '',
			facotrIds: [this.state.data.record.id]
		}).then((data) => {
			if (data.status === -1) window.location.href = '/login';
			if (data.status === 1) {
				this.showSuccessMessage('تعداد ' + data.record + ' سند صادر شد');
				this.state.caller.refreshData();
				this.closeMe();
			} else {
				this.showErorrMessage(data.message);
				this.setState({
					loading: false,
				});
			}
		});
	}
	getBlankRow(defaultIndex = null) {
		return {
			id: this.uuidv4(),
			priceAnnouncementId: null,
			index: (defaultIndex == null ? this.state.data.bodies.length + 1 : defaultIndex),
			stuffId: this.defaultGuid(),
			stuffName: '',
			stuffType: 1,
			price: 0,
			price2: 0,
			currencyRate: 0,//this.state.data.global.company.currencyRate,
			currencyId: null,
			count: 0,
			discount: 0,
			tax: 0,
			total: 0,
			prdis: 0,
			adis: 0,
			taxRate: 0,
			description: '',
			warehouseId: this.defaultGuid(),
			warehouseName: '',
			unitId: this.defaultGuid(),
			unitName: '',
			modulusCount: 0,
			modulusUnitId: this.getDefaultGuid(),
			modulusUnitName: '',
			modulusUnitRate: 0,
			takeOut: false,
			warehouseLocationId: this.getDefaultGuid(),
			warehouseLocationName: '',
			ownerId: this.getDefaultGuid(),
			ownerName: '',
			realTimeInventory: 0,
			accountId: null,
			accountName: '',
			paiedPrice: 0,
			marketerPrice: 0,
			marketerPercent: 0,
			marketerId: null,
			marketerName: '',
		};
	}
	addBlankRow() {
		this.state.data.bodies.push(this.getBlankRow());
	}
	removeRow(id) {
		this.resetRefs();
		var temp = [];
		var index = 1;
		this.state.data.bodies.sort((a, b) => a.index - b.index).forEach(r => {
			if (r.id != id) {
				temp.push(r);
				temp[temp.length - 1].index = index;
				index++;
			}
		});
		this.state.data.bodies = temp;
		this.updateFormula();
	}
	copyRow(id) {
		this.resetRefs();
		var clone = null;
		this.state.data.bodies.forEach(i => {
			if (i.id === id) {
				clone = Object.assign({}, i);
			}
		});
		clone.id = this.uuidv4();
		var startIndex = clone.index;
		for (var i = 0; i < this.state.data.bodies.length; i++) {
			if (this.state.data.bodies[i].index > startIndex) this.state.data.bodies[i].index++;
		}
		clone.index++;
		this.state.data.bodies.push(clone);
		this.updateFormula();
	}
	upIndex(id) {
		this.resetRefs();
		var idIndex = -1;
		this.state.data.bodies.forEach((r, index) => {
			if (r.id == id) idIndex = index;
		});
		if (idIndex != -1 && idIndex > 0) {
			var ii = this.state.data.bodies[idIndex].index;
			this.state.data.bodies[idIndex].index = ii - 1;
			this.state.data.bodies[idIndex - 1].index = ii;
			this.setState({ data: this.state.data });
		}
	}
	downIndex(id) {
		this.resetRefs();
		var idIndex = -1;
		this.state.data.bodies.forEach((r, index) => {
			if (r.id == id) idIndex = index;
		});
		if (idIndex != -1 && idIndex < this.state.data.bodies.length - 1) {
			var ii = this.state.data.bodies[idIndex].index;
			this.state.data.bodies[idIndex].index = ii + 1;
			this.state.data.bodies[idIndex + 1].index = ii;
			this.setState({ data: this.state.data });
		}
	}
	updateModulusCount(i) {
		this.state.data.bodies[i]['modulusCount'] = (this.state.data.bodies[i]['count'] * this.state.data.bodies[i]['modulusUnitRate']);
	}
	updateMainCount(i) {
		if (this.state.data.bodies[i]['modulusUnitRate'] === 0) this.state.data.bodies[i]['count'] = 0;
		else this.state.data.bodies[i]['count'] = this.FixedPointNumber((this.state.data.bodies[i]['modulusCount'] / this.state.data.bodies[i]['modulusUnitRate']), 3);
	}
	updateMarketerPrice(i) {
		this.state.data.bodies[i].marketerPrice = this.FixedPointNumber(((this.state.data.bodies[i].total * this.state.data.bodies[i].marketerPercent) / 100), 0);
	}
	updateMarketerPercent(i) {
		if (this.state.data.bodies[i].total != 0)
			this.state.data.bodies[i].marketerPercent = this.FixedPointNumber(((100 * this.state.data.bodies[i].marketerPrice) / this.state.data.bodies[i].total), 0);
		else
			this.state.data.bodies[i].marketerPercent = 0;
	}
	updateRealTimeInventory(bodyItem) {
		if (!this.hasRealInventory())
			return;

		this.state.data.bodies.forEach(f => {
			if (f.id == bodyItem.id) {
				this.getStuffInventory([
					{
						stuffId: bodyItem.stuffId,
						warehouseId: bodyItem.warehouseId,
						ownerId: bodyItem.ownerId,
						warehouseLocationId: bodyItem.warehouseLocationId
					}
				]).then(records => f.realTimeInventory = records[0]);
			}
		})
	}
	setType2(e) {
		if (e !== null) {
			this.state.data.record.type2Id = e.value;
			this.state.data.record.type2Name = e.label;
		}
		else {
			this.state.data.record.type2Id = null;
			this.state.data.record.type2Name = '';
		}
		this.updateAllStuffsAnnouncements();
	}
	updateAllStuffsAnnouncements() {
		if (this.state.data.global.company.saleFactorDefaultPriceMode !== 2) return;
		this.state.data.bodies.forEach(async f => {
			await this.updateAnnouncements(f.id);
		});
	}
	async updateAnnouncements(rowId) {
		var bodyRow = this.state.data.bodies.find(f => f.id === rowId);
		bodyRow.priceAnnouncementId = null;
		var price = bodyRow.price;
		var discount = bodyRow.discount;
		var stuffId = bodyRow.id;

		var prices = this.state.pricesAnnouncements.find(f => f.stuffId === stuffId);
		await this.httpPost('api/v1/stuff/getsaleprice', { id: stuffId }).then(data => {
			if (data.status === 1) {
				prices = data.prices;
				this.state.pricesAnnouncements.push({
					stuffId,
					prices: prices
				});
			}
		});

		var priceRecord = prices.find(f => (f.factorType2Id === null || f.factorType2Id === this.state.data.record.type2Id) &&
			(bodyRow.count >= f.minQuantity || f.minQuantity === 0) &&
			(bodyRow.count <= f.maxQuantity || f.maxQuantity === 0));

		if (priceRecord != null) {
			price = priceRecord.price;
			discount = priceRecord.discount;
			bodyRow.priceAnnouncementId = priceRecord.id;
		}

		this.setBodyValue(rowId, 'price', price);
		this.setBodyValue(rowId, 'discount', discount);
	}
	priceCanChange(rowId) {
		var bodyRow = this.state.data.bodies.find(f => f.id === rowId);
		if (bodyRow == null) return false;

		if (bodyRow.priceAnnouncementId != null) {
			var announcementRecord = this.state.data.priceAnnouncements.find(f => f.id === bodyRow.priceAnnouncementId);
			if (announcementRecord != null) {
				return announcementRecord.priceChange;
			}
		}

		return true;
	}
	discountCanChange(rowId) {
		var bodyRow = this.state.data.bodies.find(f => f.id === rowId);
		if (bodyRow == null) return false;

		if (bodyRow.priceAnnouncementId != null) {
			var announcementRecord = this.state.data.priceAnnouncements.find(f => f.id === bodyRow.priceAnnouncementId);
			if (announcementRecord != null) {
				return announcementRecord.discountChange;
			}
		}

		return true;
	}
	async setBodyValue(id, field, value, rowIndex = 0, columnIndex = 0) {
		for (var i = 0; i < this.state.data.bodies.length; i++) {
			if (this.state.data.bodies[i].id === id) {
				if (field == 'stuffId' || field == 'warehouseId' || field == 'unitId' || field == 'price' ||
					field == 'warehouseLocationId' ||
					field == 'ownerId' ||
					field == 'accountId' || field == 'marketerId') {
					if (field == 'stuffId') {
						this.state.data.bodies[i][field] = value.value;
						this.state.data.bodies[i]['count'] = value.defaultAmount;
						if (!this.isNull(value.description))
							this.state.data.bodies[i]['description'] = value.description;
						this.state.data.bodies[i]['unitId'] = value.unitId;
						this.state.data.bodies[i]['unitName'] = value.unitName;
						this.state.data.bodies[i]['modulusUnitId'] = value.modulusUnitId;
						this.state.data.bodies[i]['modulusUnitName'] = value.modulusUnitName;
						this.state.data.bodies[i]['modulusUnitRate'] = value.modulusUnitRate;

						if (!this.hasTax()) {
							this.state.data.bodies[i]['taxRate'] = 0;
						}
						else {
							this.state.data.bodies[i]['taxRate'] = value.taxRate;
						}

						this.state.data.bodies[i]["stuffName"] = value.label;
						this.state.data.bodies[i]['stuffType'] = value.type;

						this.state.data.bodies[i]['warehouseId'] = value.warehouseId;
						this.state.data.bodies[i]['warehouseName'] = value.warehouseName;
						this.state.data.bodies[i]['warehouseLocationId'] = this.getDefaultGuid();
						this.state.data.bodies[i]['warehouseLocationName'] = '';

						if (!this.feeFromTotal()) {
							this.state.data.bodies[i]['price'] = 0;
							if (this.state.data.record.type === 2) {
								if (this.state.data.global.company.saleFactorDefaultPriceMode === 0)
									this.state.data.bodies[i]['price'] = value.price;

								if (this.state.data.global.company.saleFactorDefaultPriceMode === 1) {
									await this.httpPost('api/v1/stuff/getsaleprice', {
										id: value.value,
									}).then(lastPrice => {
										if (lastPrice.status === 1) {
											this.state.data.bodies[i]['price'] = lastPrice.price;
										}
									});
								}

								if (this.state.data.global.company.saleFactorDefaultPriceMode === 2) {
									this.state.data.bodies[i]['price'] = value.price;
									this.updateAnnouncements(this.state.data.bodies[i]['id']);
								}
							}
							else {
								this.state.data.bodies[i]['price'] = value.price;
							}
						}

						//this.state.data.bodies[i]['currencyRate'] = this.state.data.global.company.currencyRate;
						if (this.state.data.bodies[i]['currencyRate'] !== 0)
							this.state.data.bodies[i]['price2'] = this.FixedPointNumber(parseInt(this.state.data.bodies[i]['price']) / this.state.data.global.company.currencyRate, 2);
						else
							this.state.data.bodies[i]['price2'] = 0;

						this.updateModulusCount(i);
					}
					if (field == 'accountId') {
						this.state.data.bodies[i][field] = value.value;
						this.state.data.bodies[i]["accountName"] = value.label;
					}
					if (field == 'marketerId') {
						this.state.data.bodies[i][field] = value.value;
						this.state.data.bodies[i]["marketerName"] = value.label;
					}
					if (field == 'warehouseId') {
						this.state.data.bodies[i][field] = value.value;
						this.state.data.bodies[i]["warehouseName"] = value.label;
						this.state.data.bodies[i]['warehouseLocationId'] = this.getDefaultGuid();
						this.state.data.bodies[i]['warehouseLocationName'] = '';
					}
					if (field == 'warehouseLocationId') {
						if (value === null) {
							this.state.data.bodies[i][field] = this.getDefaultGuid();
							this.state.data.bodies[i]['warehouseLocationName'] = '';
						}
						else {
							this.state.data.bodies[i][field] = value.value;
							this.state.data.bodies[i]['warehouseLocationName'] = value.label;
						}
					}
					if (field == 'ownerId') {
						if (value === null) {
							this.state.data.bodies[i][field] = this.getDefaultGuid();
							this.state.data.bodies[i]['ownerName'] = '';
						}
						else {
							this.state.data.bodies[i][field] = value.value;
							this.state.data.bodies[i]['ownerName'] = value.label;
						}
					}
					if (field == 'unitId') {
						this.state.data.bodies[i][field] = value.value;
						this.state.data.bodies[i]["unitName"] = value.label;
					}
					if (field == 'price') {
						this.state.data.bodies[i][field] = value;

						if (this.state.data.bodies[i]['currencyRate'] !== 0)
							this.state.data.bodies[i]['price2'] = this.FixedPointNumber(parseInt(this.state.data.bodies[i]['price']) / this.state.data.bodies[i]['currencyRate'], 2);
						else
							this.state.data.bodies[i]['price2'] = 0;
					}
					if (field == 'stuffId' || field == 'warehouseId' || field == 'warehouseLocationId' || field == 'ownerId') {
						this.updateRealTimeInventory(this.state.data.bodies[i]);
					}
				}
				else {
					this.state.data.bodies[i][field] = value;
				}

				if (field == 'count') {
					this.updateModulusCount(i);
				}
				if (field == 'modulusCount') {
					if (this.state.data.global.company.preventChangeMainUnitByModuluse === false) {
						this.updateMainCount(i);
					}
				}
				if (field == 'marketerPrice') {
					this.updateMarketerPercent(i);
				}
				if (field == 'marketerPercent') {
					this.updateMarketerPrice(i);
				}

				if (this.feeFromTotal()) {
					if (field == 'count' || field == 'total' || field == 'modulusCount') {
						if (this.state.data.factorValueBy == 'sub_unit') {
							if (this.state.data.bodies[i]["modulusCount"] === 0 || this.isBlank(this.state.data.bodies[i]["modulusCount"]))
								this.state.data.bodies[i]["price"] = 0;
							else
								this.state.data.bodies[i]["price"] = this.FixedPointNumber(parseInt((this.state.data.bodies[i]["total"] / this.state.data.bodies[i]["modulusCount"])), 0);
						}
						else {
							if (this.state.data.bodies[i]["count"] === 0 || this.isBlank(this.state.data.bodies[i]["count"]))
								this.state.data.bodies[i]["price"] = 0;
							else
								this.state.data.bodies[i]["price"] = this.FixedPointNumber(parseInt((this.state.data.bodies[i]["total"] / this.state.data.bodies[i]["count"])), 0);
						}
					}
				}
			}
		}
		this.updateFormula();

		//handle enter key op
		if (field == "marketerId" || field == "accountId" || field == "stuffId" || field == "warehouseId" || field == "warehouseLocationId" || field == "ownerId") {
			this.doEnterAfterSelect(rowIndex, columnIndex);
		}
	}
	doEnterAfterSelect(rowIndex, colIndex) {
		const row = this.inputRefs[rowIndex];
		const colCount = row.length;
		const rowCount = this.inputRefs.length;

		if (colCount <= colIndex && rowCount <= rowIndex) return;

		if (colIndex + 1 < colCount) {
			//find first next active input
			if (!row[colIndex + 1]) {
				this.doEnterAfterSelect(rowIndex, colIndex + 1);
			}
			else {
				row[colIndex + 1]?.focus();
				if (row[colIndex + 1]?.type === "text") row[colIndex + 1]?.select();
			}
		} else if (rowIndex + 1 < rowCount) {
			if (!this.inputRefs[rowIndex + 1][0]) {
				this.doEnterAfterSelect(rowIndex + 1, 1);
			}
			else {
				this.inputRefs[rowIndex + 1][0]?.focus();
				if (this.inputRefs[rowIndex + 1][0]?.type === "text") this.inputRefs[rowIndex + 1][0]?.select();
			}
		}
	}
	updateFormula() {
		var tprdis = 0;
		var tdis = 0;
		var tvam = 0;
		var total = 0;

		var tprdis2 = 0;
		var tdis2 = 0;
		var tvam2 = 0;
		var total2 = 0;

		var hasBlankRow = false;

		for (var i = 0; i < this.state.data.bodies.length; i++) {

			if ((this.state.data.record.type !== 9 && this.state.data.bodies[i].stuffId == this.defaultGuid()) ||
				(this.state.data.record.type === 9 && this.state.data.bodies[i].stuffId == this.defaultGuid() && this.state.data.bodies[i].ownerId == this.defaultGuid()) ) {
				hasBlankRow = true;
			}

			if (this.state.data.factorValueBy == 'sub_unit') {
				this.state.data.bodies[i]['prdis'] = parseInt(this.FixedPointNumber((this.state.data.bodies[i]['modulusCount'] * this.state.data.bodies[i]['price']), 0));
			}
			else {
				this.state.data.bodies[i]['prdis'] = parseInt(this.FixedPointNumber((this.state.data.bodies[i]['count'] * this.state.data.bodies[i]['price']), 0));
			}
			tprdis += this.state.data.bodies[i]['prdis'];

			this.state.data.bodies[i]['adis'] = this.state.data.bodies[i]['prdis'] - this.state.data.bodies[i]['discount'];
			tdis += this.state.data.bodies[i]['discount'];

			if (this.state.data.bodies[i]['taxRate'] > 0 && this.hasTax())
				this.state.data.bodies[i]['tax'] = this.FixedPointNumber((this.state.data.bodies[i]['adis'] * this.state.data.bodies[i]['taxRate']) / 100, 0);
			else
				this.state.data.bodies[i]['tax'] = 0;

			tvam += this.state.data.bodies[i]['tax'];

			if (!this.feeFromTotal()) {
				this.state.data.bodies[i]['total'] = this.state.data.bodies[i]['tax'] + this.state.data.bodies[i]['adis'];
			}

			total += this.state.data.bodies[i]['total'];

			if (this.state.data.bodies[i]['currencyRate'] !== 0) {
				tprdis2 += this.FixedPointNumber(this.state.data.bodies[i]['prdis'] / this.state.data.bodies[i]['currencyRate'], 2);
				tdis2 += this.FixedPointNumber(this.state.data.bodies[i]['discount'] / this.state.data.bodies[i]['currencyRate'], 2);
				tvam2 += this.FixedPointNumber(this.state.data.bodies[i]['tax'] / this.state.data.bodies[i]['currencyRate'], 2);
				total2 += this.FixedPointNumber(this.state.data.bodies[i]['total'] / this.state.data.bodies[i]['currencyRate'], 2);
			}
		}
		var addition = 0;
		var deduction = 0;
		this.state.data.adjustments.forEach(adj => {
			if (adj.type === 1) {
				if (adj.percent != 0)
					adj.price = this.FixedPointNumber(parseInt((total * adj.percent) / 100), 0);

				addition += adj.price;
			}
			if (adj.type === 2) {
				if (adj.percent != 0)
					adj.price = this.FixedPointNumber(parseInt((total * adj.percent) / 100), 0);

				deduction += adj.price;
			}
		});

		this.state.data.record.tprdis = tprdis;
		this.state.data.record.tdis = tdis;
		this.state.data.record.tvam = tvam;

		this.state.data.record.total = total + (addition - deduction) - this.state.data.record.discount;

		this.state.data.record.tprdis2 = tprdis2;
		this.state.data.record.tdis2 = tdis2;
		this.state.data.record.tvam2 = tvam2;
		this.state.data.record.total2 = total2;

		if (!this.fromOrdering() && !hasBlankRow && this.state.data.record.source === 1) this.addBlankRow();

		this.setState({ date: this.state.data });
	}
	setPerson(e) {
		if (e.value == -1) {
			this.state.data.record.personId = this.defaultGuid();
			this.state.data.record.personName = '';
			this.showComponents({ component: <Person Caller={this} FromAutoComplete={true} /> });
			return;
		}
		this.state.data.record.personId = e.value;
		this.state.data.record.personName = e.label;
		this.setState({ data: this.state.data });
	}
	onEditPerson(id) {
		this.showComponents({ component: <Person Caller={this} Id={id} FromAutoComplete={true} /> });
	}
	setOrdering(e) {
		if (e === null) {
			this.state.data.record.orderingId = null;
			this.state.data.record.orderingFullNumber = '';
			return;
		}
		this.state.data.record.orderingId = e.value;
		this.state.data.record.orderingFullNumber = e.label;
		this.setState({ data: this.state.data });
	}
	reciept(type) {
		this.removeKeyDown();
		this.showComponents({ component: <Receipt Source={1} RefreshAfterSave={false} FactorId={this.state.data.record.id} Type={type} Caller={this} /> });
	}
	makeTaxInvoice() {
		this.removeKeyDown();
		this.showComponents({ component: <Invoice RefreshAfterSave={false} FromFactorId={this.state.data.record.id} Caller={this} Inp={1} Ins={1} IsNew={true} /> });
	}
	setPersonMoein(e) {
		this.state.data.record.personMoeinAccountId = e.value;
		this.state.data.record.personMoeinTitle = e.label;
	}
	setCourier(e) {
		this.state.data.record.courierId = e.value;
		this.state.data.record.courierName = e.label;
		this.setState({ data: this.state.data });
	}
	setRestaurantTable(e) {
		this.state.data.record.restaurantTableId = e.value;
		this.state.data.record.restaurantTableName = e.label;
		this.setState({ data: this.state.data });
	}
	inputByBarcode(e) {
		e.preventDefault();
		this.sendBarCode(this.state.barcode);
	}
	sendBarCode(barcode) {
		if (!this.isBlank(barcode)) {
			this.httpPost("api/v1/stuff/get/barcode/", {
				barcode: barcode,
			})
				.then(data => {
					if (data.status === 1) {
						this.state.barcode = '';

						if (!this.isNull(data.record)) {
							var itemId = null;

							for (var i = 0; i < this.state.data.bodies.length; i++) {
								if (this.state.data.bodies[i].stuffId == this.defaultGuid())
									itemId = this.state.data.bodies[i].id;
							}

							this.setBodyValue(itemId, 'stuffId', data.record);
						}
					}
					this.setState({
						loading: false
					});
				});
		}
	}
	getBodySum(f) {
		var sum = 0;
		this.state.data.bodies.forEach(body => {
			sum += body[f];
		});
		return sum
	}
	getBlankAdjustmentRow(defaultIndex = null, type) {
		return {
			id: this.uuidv4(),
			index: (defaultIndex == null ? this.state.data.adjustments.length + 1 : defaultIndex),
			description: '',
			type: type,
			price: 0,
			percent: 0,
		};
	}
	addBlankAdjustmentRow(type) {
		this.state.data.adjustments.push(this.getBlankAdjustmentRow(null, type));
		this.setState({ data: this.state.data });
	}
	removeAdjustmentRow(id) {
		var temp = [];
		var index = 1;
		this.state.data.adjustments.sort((a, b) => a.index - b.index).forEach(r => {
			if (r.id != id) {
				temp.push(r);
				temp[temp.length - 1].index = index;
				index++;
			}
		});
		this.state.data.adjustments = temp;
		this.updateFormula();
	}
	copyAdjustmentRow(id) {
		var clone = null;
		this.state.data.adjustments.forEach(i => {
			if (i.id === id) {
				clone = Object.assign({}, i);
			}
		});
		clone.id = this.uuidv4();
		var startIndex = clone.index;
		for (var i = 0; i < this.state.data.adjustments.length; i++) {
			if (this.state.data.adjustments[i].index > startIndex) this.state.data.adjustments[i].index++;
		}
		clone.index++;
		this.state.data.adjustments.push(clone);
		this.updateFormula();
	}
	upIndexAdjustment(id) {
		var idIndex = -1;
		this.state.data.adjustments.forEach((r, index) => {
			if (r.id == id) idIndex = index;
		});
		if (idIndex != -1 && idIndex > 0) {
			var ii = this.state.data.adjustments[idIndex].index;
			this.state.data.adjustments[idIndex].index = ii - 1;
			this.state.data.adjustments[idIndex - 1].index = ii;
			this.setState({ data: this.state.data });
		}
	}
	downIndexAdjustment(id) {
		var idIndex = -1;
		this.state.data.adjustments.forEach((r, index) => {
			if (r.id == id) idIndex = index;
		});
		if (idIndex != -1 && idIndex < this.state.data.adjustments.length - 1) {
			var ii = this.state.data.adjustments[idIndex].index;
			this.state.data.adjustments[idIndex].index = ii + 1;
			this.state.data.adjustments[idIndex + 1].index = ii;
			this.setState({ data: this.state.data });
		}
	}
	setAdjustmentValue(id, field, value) {
		for (var i = 0; i < this.state.data.adjustments.length; i++) {
			if (this.state.data.adjustments[i].id === id) {
				if (field === 'price' || field === 'percent') {
					if (this.isBlank(value) || isNaN(value)) value = 0;
					if (field === 'price') {
						this.state.data.adjustments[i][field] = value;
						this.state.data.adjustments[i]['percent'] = 0;
					}
					if (field === 'percent') {
						this.state.data.adjustments[i][field] = value;
						this.state.data.adjustments[i]['price'] = 0;
					}
				}
				else {
					this.state.data.adjustments[i][field] = value;
				}
			}
		}
		this.updateFormula();
	}
	renderAdjustments(type) {
		return <div>
			<table className="table table-bordered acc_grid_row">
				<thead>
					<tr className="active">
						<td style={{ "width": "30px" }}>#</td>
						<td>شرح</td>
						<td style={{ "width": "100px" }}>مبلغ <span style={{ "font-weight": "normal" }} >({this.state.data.global.company.currencyUnit})</span><span className="red">*</span></td>
						<td style={{ "width": "100px" }}>درصد <span style={{ "font-weight": "normal" }} ></span><span className="red">*</span></td>
						{this.state.data.record.source === 1 && <td style={{ "width": "35px" }}></td>}
					</tr>
				</thead>
				<tbody>
					{this.state.data.adjustments.sort((a, b) => a.index - b.index).map((item, index) =>
						item.type === type && <tr key={item.id}>
							<td>
								<span className="inGridRowNumber">{(index + 1)}</span>
								<div style={{ "font-size": "9pt", "color": "silver" }}>
									{index > 0 && index != this.state.data.adjustments.length - 1 && <span onClick={e => this.upIndexAdjustment(item.id)} className="fa fa-arrow-up move-up" title="انتقال به بالا"></span>}
									{index < this.state.data.adjustments.length - 2 && <span onClick={e => this.downIndexAdjustment(item.id)} className="fa fa-arrow-down move-down" title="انتقال به پایین"></span>}
								</div>
							</td>
							<td style={{ "position": "relative" }}>
								<span className="onlyMobile">شرح: </span>
								{type === 1 && <a style={{ "position": "absolute", "font-size": "25px", "left": "0", "top": "0" }} onClick={e => this.selectTextAddjustment(9, item.id)} title="درج متن آماده"><em className="icon ni ni-property-add text-primary"></em></a>}
								{type === 2 && <a style={{ "position": "absolute", "font-size": "25px", "left": "0", "top": "0" }} onClick={e => this.selectTextAddjustment(10, item.id)} title="درج متن آماده"><em className="icon ni ni-property-add text-primary"></em></a>}
								<input type="text" className="form-control text-center" defaultValue={item.description} onChange={e => this.setAdjustmentValue(item.id, 'description', e.target.value)} />
							</td>
							<td>
								<span className="onlyMobile">مبلغ: </span>
								<NumberFormat value={item.price} onChange={e => this.setAdjustmentValue(item.id, 'price', parseInt(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control text-center ltr' /></td>
							<td>
								<span className="onlyMobile">درصد: </span>
								<NumberFormat value={item.percent} onChange={e => this.setAdjustmentValue(item.id, 'percent', parseInt(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control text-center ltr' /></td>
							{this.state.data.record.source === 1 && <td>
								<span title="حذف سطر" onClick={e => this.removeAdjustmentRow(item.id)} className="fa fa-trash fa-fw close-grid-row"></span>
								<span title="کپی سطر" onClick={e => this.copyAdjustmentRow(item.id)} className="fa fa-copy fa-fw close-grid-row"></span>
							</td>}
						</tr>
					)}
				</tbody>
			</table>
			<a className="btn btn-primary" onClick={e => this.addBlankAdjustmentRow(type)}>افزودن</a>
		</div>
	}
	getAdjustmentSum(type) {
		var s = 0;
		this.state.data.adjustments.forEach(adj => {
			if (adj.type === type) s += adj.price;
		});
		return s;
	}
	setTakeOut(e) {
		this.state.data.record.takeOut = e.target.checked;
		this.setState({ data: this.state.data });
	}
	//override
	remove() {
		var id = this.state.id_to_remove;
		if (this.isNull(id) && !this.isNull(this.state.selectedIds)) id = this.state.selectedIds;

		this.httpPost("api/v1/" + this.state.controllerName + "/remove", {
			id,
			companyId: this.state.data.global.company.id,
			organizationId: this.state.data.global.company.id,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					this.showSuccessMessage("اطلاعات با موفقیت حذف گردید");
					this.state.caller.refreshData();
					this.closeMe();
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({ showConfirmRemove: false });
				}
			})
			.catch(err => {
				this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
			});
	}
	getLastBodyId() {
		return this.state.data.bodies.sort((a, b) => b.index - a.index)[0].id;
	}
	fromOrdering() {
		if (this.state.data.record.type === 5 && !this.isBlank(this.state.data.record.orderingId) && this.state.data.record.orderingId !== this.getDefaultGuid()) return true;
		return false;
	}
	hasWarehouse() {
		if (this.state.data.global.company.warehouseSystem === true) {
			if (this.state.data.record.type === 7 || this.state.data.record.type === 8 || this.state.data.record.type === 9) return false;
			else return true;
		}
		return false;
	}
	getSumColSpan() {
		var sp = 2;
		if (this.hasWarehouse() === true) sp++;
		if (this.state.data.global.company.enableWarehouseLocation === true) sp++;
		if (this.state.data.global.company.enableWarehouseOwner === true) sp++;
		if (this.getFieldVisable("items.description")) sp++;
		return sp;
	}
	renderBody() {
		var trs = [];
		this.state.data.bodies.sort((a, b) => a.index - b.index).forEach((item, index) => {
			var tds = [];
			let refColumnIndex = 0;

			tds.push(<td>
				<span className="inGridRowNumber">{(index + 1)}</span>
				{!this.fromOrdering() && <div style={{ "font-size": "9pt", "color": "silver" }}>
					{index > 0 && index != this.state.data.bodies.length - 1 && <span onClick={e => this.upIndex(item.id)} className="fa fa-arrow-up move-up" title="انتقال به بالا"></span>}
					{index < this.state.data.bodies.length - 2 && <span onClick={e => this.downIndex(item.id)} className="fa fa-arrow-down move-down" title="انتقال به پایین"></span>}
				</div>}
			</td>);


			if (this.state.data.record.type === 9) {
				let _refColumnIndexC4 = refColumnIndex;
				
					tds.push(<td key={"owner_" + item.id + "_" + item.ownerId}>
						<SelectAsync
							isClearable={true}
							defaultValue={
								item.ownerId != this.defaultGuid()
									? [
										{
											value: item.ownerId,
											label: item.ownerName,
										},
									]
									: null
							}
							isMulti={false}
							placeholder="انتخاب"
							noOptionsMessage={({ inputValue }) =>
								inputValue ? "نتیجه‌ای یافت نشد" : null
							}
							components={{
								DropdownIndicator: () => null,
								IndicatorSeparator: () => null,
							}}
							defaultOptions={[]}
							loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback)}
							onChange={(e) =>
								this.setBodyValue(item.id, 'ownerId', e, index, _refColumnIndexC4)
							}
							ref={(el) => {
								if (!this.inputRefs[index])
									this.inputRefs[index] = [];
								this.inputRefs[index][_refColumnIndexC4] = el;
							}}
							onKeyDown={(e) => {
								if (e.key === "Enter" || e.key === "ArrowDown" || e.key === "ArrowUp") {
									const select = this.inputRefs[index][_refColumnIndexC4];
									if (this.isNull(select.state.focusedOptionId)) this.handleKeyDown(index, _refColumnIndexC4, e);
								}
							}}
						/>
					</td>);
				
				refColumnIndex++;
			}
			
			if (!this.fromOrdering() && this.state.data.record.source === 1) {
				let _refColumnIndexC1 = refColumnIndex;
				tds.push(<td key={"stuff_" + item.id + "_" + item.stuffId}>
					<span className="onlyMobile">{this.getStufColCaption()} </span>
					<SelectAsync
						defaultValue={item.stuffId != this.defaultGuid() ? [{ value: item.stuffId, label: item.stuffName }] : null}
						isMulti={false}
						placeholder="انتخاب"
						noOptionsMessage={({ inputValue }) =>
							inputValue ? "نتیجه‌ای یافت نشد" : null
						}
						defaultOptions={[]}
						components={{
							DropdownIndicator: () => null,
							IndicatorSeparator: () => null,
						}}
						loadOptions={(inputValue, callback) => this.loadStuffsOptions(inputValue, callback, ((this.state.data.record.type === 7 || this.state.data.record.type === 8) ? 2 : (this.state.data.record.type === 10 || this.state.data.record.type === 11) ? [7, 9] : this.state.data.record.type === 14 ? 8 : this.state.data.record.type === 12 ? 7 : 0))}
						onChange={e => this.setBodyValue(item.id, 'stuffId', e, index, _refColumnIndexC1)}
						ref={(el) => {
							if (!this.inputRefs[index])
								this.inputRefs[index] = [];
							this.inputRefs[index][_refColumnIndexC1] = el;
						}}
						onKeyDown={(e) => {
							if (e.key === "Enter" || e.key === "ArrowDown" || e.key === "ArrowUp") {
								const select = this.inputRefs[index][_refColumnIndexC1];
								if (this.isNull(select.state.focusedOptionId)) this.handleKeyDown(index, _refColumnIndexC1, e);
							}
						}}
					/>
				</td>);
				refColumnIndex++;
			}
			else {
				tds.push(<td>{item.stuffName}</td>);
			}

			if (this.hasWarehouse()) {
				let _refColumnIndexC2 = refColumnIndex;
				if (item.stuffType !== 2 && this.state.data.record.source === 1) {
					tds.push(<td key={"warehouse_" + item.id + "_" + item.warehouseId}>
						<span className="onlyMobile">{this.state.data.record.type !== 11 && this.state.data.record.type !== 10 ? "انبار کالا" : "سالن"}: </span>
						{item.stuffType !== 9 && <SelectAsync
							defaultValue={item.warehouseId != this.defaultGuid() ? [{ value: item.warehouseId, label: item.warehouseName }] : null}
							isMulti={false}
							placeholder="انتخاب"
							noOptionsMessage={({ inputValue }) =>
								inputValue ? "نتیجه‌ای یافت نشد" : null
							}
							defaultOptions={[]}
							components={{
								DropdownIndicator: () => null,
								IndicatorSeparator: () => null,
							}}
							loadOptions={(inputValue, callback) => this.loadWarehousesOptions(inputValue, callback, 'factor', (item.stuffType === 7 ? 1 : 0))}
							onChange={e => this.setBodyValue(item.id, 'warehouseId', e, index, _refColumnIndexC2)}
							ref={(el) => {
								if (!this.inputRefs[index])
									this.inputRefs[index] = [];
								this.inputRefs[index][_refColumnIndexC2] = el;
							}}
							onKeyDown={(e) => {
								if (e.key === "Enter" || e.key === "ArrowDown" || e.key === "ArrowUp") {
									const select = this.inputRefs[index][_refColumnIndexC2];
									if (this.isNull(select.state.focusedOptionId)) this.handleKeyDown(index, _refColumnIndexC2, e);
								}
							}}
						/>}
					</td>);
				}
				else {
					tds.push(<td>{item.warehouseName}</td>)
				}
				refColumnIndex++;
			}

			if (this.state.data.record.type !== 9 && this.state.data.global.company.enableWarehouseLocation === true) {
				let _refColumnIndexC3 = refColumnIndex;
				if (item.stuffType !== 2 && this.state.data.record.source === 1) {
					tds.push(<td key={"warehouseLocation_" + item.id + "_" + item.warehouseLocationId}>
						{item.warehouseId != this.defaultGuid() && <SelectAsync
							isClearable={true}
							defaultValue={
								item.warehouseLocationId != this.defaultGuid()
									? [
										{
											value: item.warehouseLocationId,
											label: item.warehouseLocationName,
										},
									]
									: null
							}
							isMulti={false}
							placeholder="انتخاب"
							noOptionsMessage={({ inputValue }) =>
								inputValue ? "نتیجه‌ای یافت نشد" : null
							}
							components={{
								DropdownIndicator: () => null,
								IndicatorSeparator: () => null,
							}}
							defaultOptions={[]}
							loadOptions={(inputValue, callback) => this.loadWarehouseLocationsOptions(inputValue, callback, item.warehouseId)}
							onChange={(e) =>
								this.setBodyValue(item.id, 'warehouseLocationId', e, index, _refColumnIndexC3)
							}
							ref={(el) => {
								if (!this.inputRefs[index])
									this.inputRefs[index] = [];
								this.inputRefs[index][_refColumnIndexC3] = el;
							}}
							onKeyDown={(e) => {
								if (e.key === "Enter" || e.key === "ArrowDown" || e.key === "ArrowUp") {
									const select = this.inputRefs[index][_refColumnIndexC3];
									if (this.isNull(select.state.focusedOptionId)) this.handleKeyDown(index, _refColumnIndexC3, e);
								}
							}}
						/>}
					</td>);
				}
				else {
					tds.push(<td>{item.warehouseLocationName}</td>);
				}
				refColumnIndex++;
			}

			if (this.state.data.record.type !== 9 && this.state.data.record.type !== 11 && this.state.data.record.type !== 10 && (this.state.data.global.company.enableWarehouseOwner === true)) {
				let _refColumnIndexC4 = refColumnIndex;
				if ((item.stuffType !== 2 && this.state.data.record.source === 1)) {
					tds.push(<td key={"owner_" + item.id + "_" + item.ownerId}>
						<SelectAsync
							isClearable={true}
							defaultValue={
								item.ownerId != this.defaultGuid()
									? [
										{
											value: item.ownerId,
											label: item.ownerName,
										},
									]
									: null
							}
							isMulti={false}
							placeholder="انتخاب"
							noOptionsMessage={({ inputValue }) =>
								inputValue ? "نتیجه‌ای یافت نشد" : null
							}
							components={{
								DropdownIndicator: () => null,
								IndicatorSeparator: () => null,
							}}
							defaultOptions={[]}
							loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback)}
							onChange={(e) =>
								this.setBodyValue(item.id, 'ownerId', e, index, _refColumnIndexC4)
							}
							ref={(el) => {
								if (!this.inputRefs[index])
									this.inputRefs[index] = [];
								this.inputRefs[index][_refColumnIndexC4] = el;
							}}
							onKeyDown={(e) => {
								if (e.key === "Enter" || e.key === "ArrowDown" || e.key === "ArrowUp") {
									const select = this.inputRefs[index][_refColumnIndexC4];
									if (this.isNull(select.state.focusedOptionId)) this.handleKeyDown(index, _refColumnIndexC4, e);
								}
							}}
						/>
					</td>);
				}
				else {
					tds.push(<td>{item.ownerName}</td>);
				}
				refColumnIndex++;
			}

			if (this.state.data.record.type !== 9 && this.getFieldVisable("items.description")) {
				let _refColumnIndexC5 = refColumnIndex;
				tds.push(<td>
					<span className="onlyMobile">شرح: </span>
					<input type="text" className="form-control text-center" defaultValue={item.description} onChange={e => this.setBodyValue(item.id, 'description', e.target.value)}
						ref={(el) => {
							if (!this.inputRefs[index])
								this.inputRefs[index] = [];
							this.inputRefs[index][_refColumnIndexC5] = el;
						}}
						onKeyDown={(e) => this.handleKeyDown(index, _refColumnIndexC5, e)}
					/>
				</td>);
				refColumnIndex++;
			}

			if (this.state.data.record.source === 1) {
				let _refColumnIndexC6 = refColumnIndex;
				tds.push(<td>
					<span className="onlyMobile">تعداد/مقدار: </span>
					<NumberFormat
						disabled={item.stuffType === 7}
						value={item.count}
						onChange={e => this.setBodyValue(item.id, 'count', parseFloat(e.target.value.replace(/,/g, '')))}
						thousandSeparator={true} prefix={''} className='form-control text-center ltr'
						getInputRef={(el) => {
							if (!this.inputRefs[index]) this.inputRefs[index] = [];
							this.inputRefs[index][_refColumnIndexC6] = el;
						}}
						onKeyDown={(e) => this.handleKeyDown(index, _refColumnIndexC6, e)}
					/>
				</td>);
				refColumnIndex++;
			}
			else {
				tds.push(<td>{item.count}</td>);
			}

			if (this.state.data.record.type !== 9) tds.push(<td><span className="onlyMobile">واحد اصلی: </span>{item.unitName}</td>);

			if (this.showSubUnitCol()) {
				if (this.state.data.record.source === 1) {
					let _refColumnIndexC7 = refColumnIndex;
					tds.push(<td>
						<span className="onlyMobile">تعداد/مقدار فرعی: </span>
						<NumberFormat value={item.modulusCount} onChange={e => this.setBodyValue(item.id, 'modulusCount', parseFloat(e.target.value.replace(/,/g, '')))}
							thousandSeparator={true} prefix={''} className='form-control text-center ltr'
							getInputRef={(el) => {
								if (!this.inputRefs[index]) this.inputRefs[index] = [];
								this.inputRefs[index][_refColumnIndexC7] = el;
							}}
							onKeyDown={(e) => this.handleKeyDown(index, _refColumnIndexC7, e)} />
					</td>);
					refColumnIndex++;
				}
				else {
					tds.push(<td>{item.modulusCount}</td>);
				}
			}

			if (this.showSubUnitCol()) {
				tds.push(<td>
					<span className="onlyMobile">واحد فرعی: </span>{item.modulusUnitName}</td>);
			}

			if (this.hasPrice()) {
				let _refColumnIndexC8 = refColumnIndex;
				tds.push(<td>
					<span className="onlyMobile">مبلغ: </span>
					<NumberFormat
						value={item.price}
						onChange={e => this.setBodyValue(item.id, 'price', parseInt(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control text-center ltr'
						getInputRef={(el) => {
							if (!this.inputRefs[index]) this.inputRefs[index] = [];
							this.inputRefs[index][_refColumnIndexC8] = el;
						}}
						onKeyDown={(e) => this.handleKeyDown(index, _refColumnIndexC8, e)}
						disabled={this.feeFromTotal() || !this.priceCanChange(item.id)}
					/>
				</td>);
				refColumnIndex++;
			}

			if (this.state.data.record.type !== 9 && this.state.data.global.company.enableMultiCurrency === 2) {
				let _refColumnIndexC9 = refColumnIndex;
				tds.push(<td>
					<span className="onlyMobile">ارز: </span>
					<select defaultValue={item.currencyId} onChange={e => this.setBodyValue(item.id, 'currencyId', e.target.value)} className='form-control text-center ltr'
						getInputRef={(el) => {
							if (!this.inputRefs[index]) this.inputRefs[index] = [];
							this.inputRefs[index][_refColumnIndexC9] = el;
						}}
						onKeyDown={(e) => this.handleKeyDown(index, _refColumnIndexC9, e)}>
						<option value="">انتخاب</option>
						{this.state.data.global.currencies.map(cur => <option value={cur.value}>{cur.label}</option>)}
					</select></td>);
				refColumnIndex++;
			}

			if (this.state.data.record.type !== 9 && this.state.data.global.company.enableMultiCurrency === 2) {
				let _refColumnIndexC10 = refColumnIndex;
				tds.push(<td>
					<span className="onlyMobile">نرخ ارز: </span>
					<NumberFormat value={item.currencyRate} onChange={e => this.setBodyValue(item.id, 'currencyRate', parseInt(e.target.value.replace(/,/g, '')))} thousandSeparator={false} prefix={''} className='form-control text-center ltr'
						getInputRef={(el) => {
							if (!this.inputRefs[index]) this.inputRefs[index] = [];
							this.inputRefs[index][_refColumnIndexC10] = el;
						}}
						onKeyDown={(e) => this.handleKeyDown(index, _refColumnIndexC10, e)} /></td>);
				refColumnIndex++;
			}

			if (this.state.data.record.type !== 9 && this.state.data.global.company.enableMultiCurrency === 2) {
				//let _refColumnIndexC12 = refColumnIndex;
				tds.push(<td>
					<span className="onlyMobile">مبلغ ارزی: </span>
					<NumberFormat readOnly={true} value={item.price2} onChange={e => this.setBodyValue(item.id, 'price2', parseInt(e.target.value.replace(/,/g, '')))} thousandSeparator={false} prefix={''} className='form-control text-center ltr' /></td>);
				//refColumnIndex++;
			}

			if (this.hasDiscount()) {
				let _refColumnIndexC11 = refColumnIndex;
				tds.push(<td>
					<span className="onlyMobile">تخفیف: </span>
					<NumberFormat value={item.discount} onChange={e => this.setBodyValue(item.id, 'discount', parseInt(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control text-center ltr'
						getInputRef={(el) => {
							if (!this.inputRefs[index]) this.inputRefs[index] = [];
							this.inputRefs[index][_refColumnIndexC11] = el;
						}}
						onKeyDown={(e) => this.handleKeyDown(index, _refColumnIndexC11, e)}
						disabled={!this.discountCanChange(item.id)}
					/></td>);
				refColumnIndex++;
			}

			if (this.hasDiscount()) {
				tds.push(<td>
					<span className="onlyMobile">مبلغ بعد از تخفیف: </span>
					<NumberFormat readOnly={true} value={item.adis} thousandSeparator={true} prefix={''} className='form-control text-center ltr'
					/></td>);
			}

			if (this.hasTax()) {
				tds.push(<td>
					<span className="onlyMobile">مالیات: </span>
					<NumberFormat readOnly={true} value={item.tax} thousandSeparator={true} prefix={''} className='form-control text-center ltr'
					/></td>);
			}

			if (this.state.data.record.type === 14 || this.state.data.record.type === 13 || this.state.data.record.type === 9) {
				let _refColumnIndexC13 = refColumnIndex;
				tds.push(<td key={"account_" + item.id + "_" + item.accountId}>
					<SelectAsync
						isClearable={true}
						defaultValue={
							item.accountId !== null
								? [
									{
										value: item.accountId,
										label: item.accountName,
									},
								]
								: null
						}
						isMulti={false}
						placeholder="انتخاب"
						noOptionsMessage={({ inputValue }) =>
							inputValue ? "نتیجه‌ای یافت نشد" : null
						}
						components={{
							DropdownIndicator: () => null,
							IndicatorSeparator: () => null,
						}}
						defaultOptions={[]}
						loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 4, null, ((this.state.data.record.type === 14 || this.state.data.record.type === 13) ? [10] : this.state.data.record.type === 9 ? [3, 4] : null))}
						onChange={(e) =>
							this.setBodyValue(item.id, 'accountId', e, index, _refColumnIndexC13)
						}
						ref={(el) => {
							if (!this.inputRefs[index])
								this.inputRefs[index] = [];
							this.inputRefs[index][_refColumnIndexC13] = el;
						}}
						onKeyDown={(e) => {
							if (e.key === "Enter" || e.key === "ArrowDown" || e.key === "ArrowUp") {
								const select = this.inputRefs[index][_refColumnIndexC13];
								if (this.isNull(select.state.focusedOptionId)) this.handleKeyDown(index, _refColumnIndexC13, e);
							}
						}}
					/>
				</td>);

				refColumnIndex++;
			}
			if (this.hasTotal()) {
				tds.push(<td>
					<span className="onlyMobile">جمع کل: </span>
					<NumberFormat
						disabled={!this.feeFromTotal()}
						onChange={e => this.setBodyValue(item.id, 'total', parseInt(e.target.value.replace(/,/g, '')))}
						value={item.total} thousandSeparator={true} prefix={''} className='form-control text-center ltr'
					/>
				</td>);
			}

			if (this.hasPaiedPriceCol()) {
				let _refColumnIndexC14 = refColumnIndex;
				tds.push(<td>
					<NumberFormat
						value={item.paiedPrice}
						onChange={(e) => this.setBodyValue(item.id, 'paiedPrice', parseInt(e.target.value.replace(/,/g, '')))}
						thousandSeparator={true}
						prefix={''}
						className="form-input text-center ltr"
						getInputRef={(el) => {
							if (!this.inputRefs[index]) this.inputRefs[index] = [];
							this.inputRefs[index][_refColumnIndexC14] = el;
						}}
						onKeyDown={(e) => this.handleKeyDown(index, _refColumnIndexC14, e)}
					/>
				</td>);
				refColumnIndex++;
			}

			if (this.hasMarketingCol()) {
				let _refColumnIndexC15 = refColumnIndex;
				tds.push(<td key={"marketing_" + item.id + "_" + item.marketerId}>
					<SelectAsync
						isClearable={true}
						defaultValue={
							item.marketerId !== null
								? [
									{
										value: item.marketerId,
										label: item.marketerName,
									},
								]
								: null
						}
						isMulti={false}
						placeholder="انتخاب"
						noOptionsMessage={({ inputValue }) =>
							inputValue ? "نتیجه‌ای یافت نشد" : null
						}
						components={{
							DropdownIndicator: () => null,
							IndicatorSeparator: () => null,
						}}
						defaultOptions={[]}
						loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback)}
						onChange={(e) =>
							this.setBodyValue(item.id, 'marketerId', e, index, _refColumnIndexC15)
						}
						ref={(el) => {
							if (!this.inputRefs[index])
								this.inputRefs[index] = [];
							this.inputRefs[index][_refColumnIndexC15] = el;
						}}
						onKeyDown={(e) => {
							if (e.key === "Enter" || e.key === "ArrowDown" || e.key === "ArrowUp") {
								const select = this.inputRefs[index][_refColumnIndexC15];
								if (this.isNull(select.state.focusedOptionId)) this.handleKeyDown(index, _refColumnIndexC15, e);
							}
						}}
					/>
				</td>);

				refColumnIndex++;
			}

			if (this.hasMarketingCol()) {
				let _refColumnIndexC16 = refColumnIndex;
				tds.push(<td>
					<NumberFormat
						value={item.marketerPercent}
						onChange={(e) => this.setBodyValue(item.id, 'marketerPercent', parseInt(e.target.value.replace(/,/g, '')))}
						thousandSeparator={true}
						prefix={''}
						className="form-input text-center ltr"
						getInputRef={(el) => {
							if (!this.inputRefs[index]) this.inputRefs[index] = [];
							this.inputRefs[index][_refColumnIndexC16] = el;
						}}
						onKeyDown={(e) => this.handleKeyDown(index, _refColumnIndexC16, e)}
					/>
				</td>);
				refColumnIndex++;
			}

			if (this.hasMarketingCol()) {
				let _refColumnIndexC17 = refColumnIndex;
				tds.push(<td>
					<NumberFormat
						value={item.marketerPrice}
						onChange={(e) => this.setBodyValue(item.id, 'marketerPrice', parseInt(e.target.value.replace(/,/g, '')))}
						thousandSeparator={true}
						prefix={''}
						className="form-input text-center ltr"
						getInputRef={(el) => {
							if (!this.inputRefs[index]) this.inputRefs[index] = [];
							this.inputRefs[index][_refColumnIndexC17] = el;
						}}
						onKeyDown={(e) => this.handleKeyDown(index, _refColumnIndexC17, e)}
					/>
				</td>);
				refColumnIndex++;
			}

			if (this.state.data.global.company.mainBussinessType === 1) {
				tds.push(<td>
					<span className="onlyMobile">بیرون بر: </span>
					<input type="checkbox" onChange={e => this.setBodyValue(item.id, 'takeOut', e.target.checked)} defaultChecked={item.takeOut} />
				</td>);
			}

			if (this.hasRealInventory()) {
				tds.push(<td>
					{this.FixedPointNumber(item.realTimeInventory, 3)}
				</td>);
			}

			if (this.state.data.record.source === 1) {
				tds.push(<td>
					{item.stuffId != this.defaultGuid() && <span title="حذف سطر" onClick={e => this.removeRow(item.id)} className="fa fa-trash fa-fw close-grid-row"></span>}
					{!this.fromOrdering() && item.stuffId != this.defaultGuid() && <span title="کپی سطر" onClick={e => this.copyRow(item.id)} className="fa fa-copy fa-fw close-grid-row"></span>}
				</td>);
			}

			trs.push(<tr key={item.id} id={(this.state.highlightedStuffs.includes(item.stuffId) ? "highlightedStuffs_" + item.stuffId : "")} className={(this.state.highlightedStuffs.includes(item.stuffId) ? "highlighted" : "")}>
				{tds}
			</tr>);
		});

		return <tbody>{trs}</tbody>
	}

	showSubUnitCol() {
		if (this.state.data.record.type !== 13 && this.state.data.record.type !== 9 && this.state.data.global.company.stuffSubUnitEnable === 2) return true;
		else return false;
	}
	hasTax() {
		if (this.state.data.record.type === 9 && this.state.data.record.type === 5 ||
			this.state.data.record.type === 10 || this.state.data.record.type === 11 ||
			this.state.data.record.type === 13 || this.state.data.record.type === 14 ||
			this.state.data.record.type === 12) return false;
		return true;
	}
	hasDiscount() {
		if (this.state.data.record.type === 9 && this.state.data.record.type === 5 ||
			this.state.data.record.type === 10 || this.state.data.record.type === 11 ||
			this.state.data.record.type === 13 || this.state.data.record.type === 14 ||
			this.state.data.record.type === 12) return false;
		return true;
	}
	feeFromTotal() {
		if (this.state.data.record.type === 10 || this.state.data.record.type === 11) return true;
		else return false;
	}
	getStufColCaption() {
		if (this.state.data.record.type === 11 || this.state.data.record.type === 10) return "نوع دام";
		if (this.state.data.record.type === 13) return "شماره گوشواره";
		if (this.state.data.record.type === 13) return "خوراک مصرفی";
		if (this.state.data.record.type === 14) return "داروی مصرفی";
		return "کالا/خدمت";
	}
	hasPrice() {
		if (this.state.data.record.type === 13 || this.state.data.record.type === 14) return false;
		return true;
	}
	hasTotal() {
		if (this.state.data.record.type === 13 || this.state.data.record.type === 14) return false;
		return true;
	}
	hasMarketingCol() {
		return this.state.data.record.type === 9;
	}
	hasPaiedPriceCol() {
		return this.state.data.record.type === 9;
	}
	hasRealInventory() {
		if (this.state.data.record.type === 13 || this.state.data.record.type === 14 ||
			this.state.data.record.type === 11 || this.state.data.record.type === 10 ||
			this.state.data.record.type === 9 || this.state.data.record.type === 12) return false;
		return true;
	}
	nutritionDispatch() {
		if (this.state.nutrition === null) {
			this.showErorrMessage("لطفا خوراک مورد نظر را انتخاب نمایید");
			return;
		}
		if (this.state.nutritionWarehouse === null) {
			this.showErorrMessage("لطفا انبار مصرفی مورد نظر را انتخاب نمایید");
			return;
		}
		if (this.isBlank(this.state.nutritionAmount)) this.state.nutritionAmount = 0;
		this.state.nutritionAmount = parseFloat(this.state.nutritionAmount);

		if (this.state.nutritionAmount <= 0) {
			this.showErorrMessage("لطفا میانگین خوراک هر دام را مشخص نمایید");
			return;
		}

		this.httpPost('api/v1/report/farm/currentanimals', {}).then((data) => {
			if (data.status === -1) window.location.href = '/login';
			if (data.status === 1) {

				for (var i = 0; i < data.records.length; i++) {
					var itemId = this.getLastBodyId();
					this.setBodyValue(itemId, 'stuffId', this.state.nutrition);
					this.setBodyValue(itemId, 'warehouseId', this.state.nutritionWarehouse);
					this.setBodyValue(itemId, 'accountId', { value: data.records[i].accountId, label: data.records[i].name });
					this.setBodyValue(itemId, 'count', this.state.nutritionAmount);
				}

				this.setState({ nutrition: null, nutritionAmount: 0, nutritionVersion: this.uuidv4() });

			} else {
				//this.showErorrMessage(data.message);
				this.setState({
					data: data,
					loading: false,
				});
			}
		});
	}
	renderForm() {
		return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
			<div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
			<div className="modal-dialog ui-draggable" style={{ "width": "96%", "left": "7.125px", "top": "-2px" }}>
				<div className="modal-content">
					<div className="modal-body">
						<div className="modal-header modal-header-info" style={{ "padding": "0" }}>
							<button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
							<h4 className="modal-title">
								{this.state.data.record.type === 2 && <span>فاکتور فروش</span>}
								{this.state.data.record.type === 1 && <span>فاکتور خرید</span>}
								{this.state.data.record.type === 6 && <span>فاکتور خرید خارجی</span>}
								{this.state.data.record.type === 4 && <span>فاکتور برگشت از فروش</span>}
								{this.state.data.record.type === 3 && <span>فاکتور برگشت از خرید</span>}
								{this.state.data.record.type === 5 && <span>فاکتور ضایعات</span>}
								{this.state.data.record.type === 8 && <span>فاکتور فروش خدمات</span>}
								{this.state.data.record.type === 7 && <span>فاکتور خرید خدمات</span>}

								{this.state.data.record.type === 10 && <span>فاکتور خرید دام</span>}
								{this.state.data.record.type === 11 && <span>فاکتور فروش دام</span>}
								{this.state.data.record.type === 12 && <span>تلفات دام</span>}
								{this.state.data.record.type === 13 && <span>خوراک دام</span>}
								{this.state.data.record.type === 14 && <span>واکسیناسیون دام</span>}
							</h4>
						</div>
						<div className="modal-body" style={{ "display": "flex", "flex-direction": "column", "gap": "10px" }}>
							<div className="row">
								{this.state.data.record.type !== 13 && this.state.data.record.type !== 14 && this.state.data.record.type !== 9 && <div className="col-sm-3">
									<div className="form-group">
										<label for="invoiceDate" className="title1">معین طرف حساب <span className="red">*</span></label>
										{this.state.data.record.source !== 1 ? <span>{this.state.data.record.personMoeinTitle}</span>
											:
											<SelectAsync
												style={{ "width": "100%" }}
												defaultValue={this.state.data.record.personMoeinAccountId !== this.getDefaultGuid() ? [{ value: this.state.data.record.personMoeinAccountId, label: this.state.data.record.personMoeinTitle }] : null}
												isMulti={false}
												placeholder="انتخاب معین طرف حساب"
												noOptionsMessage={({ inputValue }) =>
													inputValue ? "نتیجه‌ای یافت نشد" : null
												}
												defaultOptions={[]}
												components={{
													DropdownIndicator: () => null,
													IndicatorSeparator: () => null,
												}}
												loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 3)}
												onChange={e => this.setPersonMoein(e)}
											/>
										}
									</div>
								</div>}
								{this.state.data.record.type !== 12 && this.state.data.record.type !== 13 && this.state.data.record.type !== 14 && this.state.data.record.type !== 9 && this.state.data.record.type !== 5 &&
									<div className="col-sm-3">
										<div className="form-group">
											<label for="invoiceContact" className="title1">طرف حساب<span className="red">*</span></label>
											<div id="displayPersonBalance" style={{ "display": "inline-block" }} ></div>
											{((this.state.data.record.type !== 4 && this.state.data.record.type !== 3) || this.isNull(this.state.data.refInvoice)) ?
												[
													<em className="icon ni ni-plus hand ms-1" onClick={e => this.setPerson({ value: -1 })}></em>,
													!this.isNull(this.state.data.record.personId) && this.state.data.record.personId != this.defaultGuid() && <em onClick={e => this.onEditPerson(this.state.data.record.personId)} className="icon ni ni-pen hand ms-1"></em>,
													this.state.data.record.source !== 1 ? <span>{this.state.data.record.personName}</span>
														:
														<SelectAsync
															value={!this.isNull(this.state.data.record.personId) && this.state.data.record.personId != this.defaultGuid() ? [{ value: this.state.data.record.personId, label: this.state.data.record.personName }] : null}
															isMulti={false}
															placeholder="انتخاب طرف حساب"
															noOptionsMessage={({ inputValue }) =>
																inputValue ? "نتیجه‌ای یافت نشد" : null
															}
															defaultOptions={[]}
															components={{
																DropdownIndicator: () => null,
																IndicatorSeparator: () => null,
															}}
															loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback, 1, ((this.state.data.record.type === 1 || this.state.data.record.type === 6 || this.state.data.record.type === 7 || this.state.data.record.type === 3 || this.state.data.record.type === 10) ? 2 : 1))}
															onChange={e => this.setPerson(e)}
														/>
												]
												:
												<div id="invoiceComboContact">{this.state.data.refInvoice.person.name}</div>}
										</div>
									</div>}

								{this.state.orderingId === this.defaultGuid() && this.state.data.record.type === 1 &&
									<div className="col-sm-3">
										<div className="form-group">
											<label for="invoiceContact" className="title1">سفارش</label>
											<SelectAsync
												value={!this.isNull(this.state.data.record.orderingId) && this.state.data.record.orderingId != this.defaultGuid() ? [{ value: this.state.data.record.orderingId, label: this.state.data.record.orderingFullNumber }] : null}
												isMulti={false}
												placeholder="انتخاب سفارش"
												noOptionsMessage={({ inputValue }) =>
													inputValue ? "نتیجه‌ای یافت نشد" : null
												}
												defaultOptions={[]}
												components={{
													DropdownIndicator: () => null,
													IndicatorSeparator: () => null,
												}}
												loadOptions={(inputValue, callback) => this.loadOrderingsOptions(inputValue, callback, 4)}
												onChange={e => this.setOrdering(e)}
											/>
										</div>
									</div>}

								{this.state.orderingId === this.defaultGuid() && this.state.data.record.type === 6 &&
									<div className="col-sm-3">
										<div className="form-group">
											<label for="invoiceContact" className="title1">سفارش</label>
											<SelectAsync
												value={!this.isNull(this.state.data.record.orderingId) && this.state.data.record.orderingId != this.defaultGuid() ? [{ value: this.state.data.record.orderingId, label: this.state.data.record.orderingFullNumber }] : null}
												isMulti={false}
												placeholder="انتخاب سفارش"
												noOptionsMessage={({ inputValue }) =>
													inputValue ? "نتیجه‌ای یافت نشد" : null
												}
												defaultOptions={[]}
												components={{
													DropdownIndicator: () => null,
													IndicatorSeparator: () => null,
												}}
												loadOptions={(inputValue, callback) => this.loadOrderingsOptions(inputValue, callback, 8)}
												onChange={e => this.setOrdering(e)}
											/>
										</div>
									</div>}

								{(this.state.data.record.type === 2 || this.state.data.record.type === 8) && <div className="col-lg-1">
									<div className="form-group">
										<label className="form-title1">نوع فروش</label>
										<SelectAsync
											defaultValue={
												this.state.data.record.type2Id === null
													? [
														{
															value: this.state.data.record.type2Id,
															label: this.state.data.record.type2Name,
														},
													]
													: null
											}
											isMulti={false}
											placeholder="انتخاب"
											noOptionsMessage={({ inputValue }) =>
												inputValue ? "نتیجه‌ای یافت نشد" : null
											}
											components={{
												DropdownIndicator: () => null,
												IndicatorSeparator: () => null,
											}}
											defaultOptions={[]}
											loadOptions={(inputValue, callback) => this.loadConstantsOptions(inputValue, callback, 12)}
											onChange={(e) => this.setType2(e)}
										/>
									</div>
								</div>}
								{this.state.data.record.source === 1 && <div className="col-sm-1">
									<div className="form-group">
										<label for="invoiceDate" className="title1">تاریخ<span className="red">*</span></label>
										{this.state.enableDatePicker === true ? <DatePicker
											inputReadOnly={false}
											className="form-control input-sm persian-date"
											placeholder={"تاریخ"}
											isGregorian={false}
											showTodayButton={true}
											timePicker={false}
											onChange={(e) => { this.state.data.record.date = e }}
											value={this.getFormatedDateForDatePicker(this.state.data.record.date)}
										/> :
											<input
												onChange={(e) => this.state.data.record.dateString = e.target.value}
												defaultValue={this.state.data.record.dateString}
												autoComplete="off"
												placeholder={'تاریخ'}
												type="text"
												className="form-control ltr"
												maxLength="10"
											/>}
									</div>
								</div>}
								{this.state.data.record.type !== 12 && this.state.data.record.type !== 13 && this.state.data.record.type !== 14 && this.state.data.record.type !== 9 && <div className="col-sm-1">
									<div className="form-group">
										<label className="title1">اعتبار(روز)</label>
										{this.state.data.record.source !== 1 ? <span>{this.state.data.record.expireDuration}</span>
											:
											<input onChange={e => this.state.data.record.expireDuration = parseInt(e.target.value)} defaultValue={this.state.data.record.expireDuration} autocomplete="off" type="text" className="form-control input-smnumber" maxlength="20" />
										}
									</div>
								</div>}
								<div className="col-sm-1">
									<div className="form-group">
										<label className="title1">شماره</label>
										{this.state.data.record.source !== 1 ? <span>{this.state.data.record.number}</span>
											:
											<input onChange={e => this.state.data.record.number = parseInt(e.target.value)} defaultValue={this.state.data.record.number} autocomplete="off" type="text" className="form-control input-smnumber" maxlength="20" />
										}
									</div>
								</div>

								{this.hasWarehouse() === true &&
									this.state.data.record.source === 1 &&
									(this.state.data.record.type === 1 || this.state.data.record.type === 6 || this.state.data.record.type === 2) && <div className="col-sm-1">
										<div className="form-group">
											{(this.state.data.record.type === 1 || this.state.data.record.type === 6) && <label className="title1">صدور رسید</label>}
											{this.state.data.record.type === 2 && <label className="title1">صدور حواله</label>}
											<select onChange={(e) => this.state.data.record.manualRemittance = e.target.value === "1"}
												defaultValue={this.state.data.record.manualRemittance ? "1" : "0"}
												autoComplete="off" className="form-input">
												<option value="0">خودکار</option>
												<option value="1">دستی</option>
											</select>
										</div>
									</div>}

								{this.state.data.global.company.mainBussinessType === 1 && <div className="col-sm-2">
									<div className="form-group">
										<label className="title1">میز</label>
										<SelectAsync
											value={!this.isNull(this.state.data.record.restaurantTableId) && this.state.data.record.restaurantTableId != this.defaultGuid() ? [{ value: this.state.data.record.restaurantTableId, label: this.state.data.record.restaurantTableName }] : null}
											isMulti={false}
											placeholder="انتخاب میز"
											noOptionsMessage={({ inputValue }) =>
												inputValue ? "نتیجه‌ای یافت نشد" : null
											}
											defaultOptions={[]}
											components={{
												DropdownIndicator: () => null,
												IndicatorSeparator: () => null,
											}}
											loadOptions={(inputValue, callback) => this.loadRestaurantTablesOptions(inputValue, callback)}
											onChange={e => this.setRestaurantTable(e)}
										/>
									</div>
								</div>}
								{this.state.data.global.company.mainBussinessType === 1 && <div className="col-sm-1" style={{ "display": "flex", "alignItems": "self-end" }}>
									<div className="form-group">
										<input onChange={e => this.setTakeOut(e)} defaultChecked={this.state.data.record.takeOut} autocomplete="off" type="checkbox" />
										<label className="title1">بیرون بر</label>
									</div>
								</div>}
								{this.state.data.record.takeOut === true && this.state.data.global.company.mainBussinessType === 1 && <div className="col-sm-3">
									<div className="form-group">
										<label className="title1">پیک</label>
										<SelectAsync
											value={!this.isNull(this.state.data.record.courierId) && this.state.data.record.courierId != this.defaultGuid() ? [{ value: this.state.data.record.courierId, label: this.state.data.record.courierName }] : null}
											isMulti={false}
											placeholder="انتخاب پیک"
											noOptionsMessage={({ inputValue }) =>
												inputValue ? "نتیجه‌ای یافت نشد" : null
											}
											defaultOptions={[]}
											components={{
												DropdownIndicator: () => null,
												IndicatorSeparator: () => null,
											}}
											loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback, 0, 13)}
											onChange={e => this.setCourier(e)}
										/>
									</div>
								</div>}
								{this.state.data.global.company.mainBussinessType === 1 && <div className="col-sm-12">
									<div className="form-group">
										<label className="title1">آدرس</label>
										<input onChange={e => this.state.data.record.address = e.target.value} defaultValue={this.state.data.record.address} autocomplete="off" type="text" className="form-control input-smnumber" />
									</div>
								</div>}
							</div>
							{this.state.data.record.type !== 11 && this.state.data.record.type !== 10 && this.state.data.record.type !== 9 && <div className="row mr-b-20">
								{!this.fromOrdering() && this.state.data.record.source === 1 && <div className="col-md-4">
									<label className="title1">ورود بارکدخوان</label>
									<form key={"barcode_" + this.state.barcode} onSubmit={e => this.inputByBarcode(e)}>
										<input autocomplete="off" onChange={e => this.state.barcode = e.target.value} defaultValue={this.state.barcode} type="text" placeholder="بارکد کالا ..." className="form-control ltr" style={{ "width": "100%" }} maxlength="150" />
										<input autocomplete="off" type="submit" className="hidden" />
									</form>
								</div>}
								{this.state.data.record.type !== 5 && <div className="col-md-8">
									<label className="title1">توضیحات</label>
									<input onChange={e => this.state.data.record.description = e.target.value} defaultValue={this.state.data.record.description} autocomplete="off" type="text" className="form-control input-sm ng-valid" style={{ "width": "100%" }} maxlength="150" />
								</div>
								}
							</div>}

							{this.state.data.record.type !== 12 && this.state.data.record.type !== 14 && this.state.data.record.type !== 13 && this.state.data.record.type !== 9 && <ul className="nav nav-tabs mt-n3" role="tablist">
								<li className="nav-item" role="presentation">
									<a className="nav-link active" data-bs-toggle="tab" href="#tab1" aria-selected="false" role="tab" tabindex="-1"><span>اقلام فاکتور</span></a>
								</li>
								<li className="nav-item" role="presentation">
									<a className="nav-link" data-bs-toggle="tab" href="#tab2" aria-selected="false" tabindex="-1" role="tab"><span>عوامل افزاینده</span></a>
								</li>
								<li className="nav-item" role="presentation">
									<a className="nav-link" data-bs-toggle="tab" href="#tab3" aria-selected="false" tabindex="-1" role="tab"><span>عوامل کاهنده</span></a>
								</li>
								{this.state.data.record.id !== this.getDefaultGuid() && <li className="nav-item" role="presentation">
									<a className="nav-link" data-bs-toggle="tab" href="#tab4" aria-selected="false" tabindex="-1" role="tab"><span>گردش کار</span></a>
								</li>}
							</ul>}
							<div className="tab-content">
								<div className="tab-pane active" id="tab1" role="tabpanel">
									<div className="row">
										{!this.fromOrdering() && !this.isEmpty(this.state.data.menuCollection) && <div className="col-lg-2">
											{this.state.data.menuCollection.map(menu => <div style={{ "display": "flex", "flex-direction": "column", "gap": "5px", "border-bottom": "1px gray solid", "padding-bottom": "5px", "margin-bottom": "5px" }}>
												<h6>{menu.name}</h6>
												{menu.items.map(item => <a className="hand" onClick={e => this.setBodyValue(this.getLastBodyId(), 'stuffId', item)} style={{ "display": "flex", "align-items": "center", "gap": "5px" }}>
													{!this.isBlank(item.image) && <img src={item.image} style={{ "width": "50px", "border-radius": "6px" }} />}
													{item.label}
												</a>)}
											</div>)}
										</div>}
										<div className={(!this.fromOrdering() && !this.isEmpty(this.state.data.menuCollection)) ? "col-lg-10" : "col-lg-12"}>
											{this.state.data.record.type === 13 && <div style={{ display: "flex", alignItems: "center", placeContent: "center", gap: "9px", backgroundColor: "#f4f6f8" }} key={"nut_" + this.state.nutritionVersion}>
												<div className="col-md-4">
													<label className="form-label">خوراک مصرف شده</label>
													<SelectAsync
														defaultValue={this.state.nutrition}
														isMulti={false}
														placeholder="انتخاب"
														noOptionsMessage={({ inputValue }) =>
															inputValue ? "نتیجه‌ای یافت نشد" : null
														}
														components={{
															DropdownIndicator: () => null,
															IndicatorSeparator: () => null,
														}}
														defaultOptions={[]}
														loadOptions={(inputValue, callback) => this.loadStuffsOptions(inputValue, callback, 1)}
														onChange={(e) => {
															this.state.nutrition = e;
														}
														}
													/>
												</div>
												<div className="col-md-4">
													<label className="form-label">انبار مصرفی</label>
													<SelectAsync
														defaultValue={this.state.nutritionWarehouse}
														isMulti={false}
														placeholder="انتخاب"
														noOptionsMessage={({ inputValue }) =>
															inputValue ? "نتیجه‌ای یافت نشد" : null
														}
														components={{
															DropdownIndicator: () => null,
															IndicatorSeparator: () => null,
														}}
														defaultOptions={[]}
														loadOptions={(inputValue, callback) => this.loadWarehousesOptions(inputValue, callback, 'factor', 0)}
														onChange={(e) => this.setState({ nutritionWarehouse: e })}
													/>
												</div>
												<div className="col-md-2">
													<label className="form-label">میانگین وزن خوراک</label>
													<input
														onChange={(e) => this.state.nutritionAmount = e.target.value}
														defaultValue={this.state.nutritionAmount}
														autoComplete="off"
														type="text"
														className="form-control"
														style={{ width: '100%' }}
														maxLength="150"
													/>
												</div>
												<a className="btn btn-warning" onClick={e => this.nutritionDispatch()}>توزیع خوراک</a>												
											</div>}
											<table className="table table-bordered acc_grid_row">
												<thead>
													<tr className="active">
														<td style={{ "width": "30px" }}>#</td>
														{this.state.data.record.type === 9 && <th>شخص</th>}
														<td style={{ minWidth: "200px" }}>{this.getStufColCaption()}</td>
														{this.hasWarehouse() && <td>{this.state.data.record.type !== 11 && this.state.data.record.type !== 10 ? "انبار کالا" : "سالن"}</td>}
														{this.state.data.record.type !== 11 && this.state.data.record.type !== 10 && this.state.data.record.type !== 9 && this.state.data.global.company.enableWarehouseLocation === true && <th>جایگاه</th>}
														{this.state.data.record.type !== 9 && this.state.data.record.type !== 11 && this.state.data.record.type !== 10 && (this.state.data.global.company.enableWarehouseOwner === true) && <th>مالک</th>}
														{this.state.data.record.type !== 9 && this.getFieldVisable("items.description") && <td>شرح</td>}
														<td style={{ "width": "70px" }}><span>تعداد/مقدار</span></td>
														{this.state.data.record.type !== 9 && <td>واحد اصلی</td>}
														{this.showSubUnitCol() && <td style={{ "width": "70px" }}>
															<span>تعداد/مقدار<br />فرعی</span>
														</td>}
														{this.showSubUnitCol() && <td>واحد فرعی</td>}
														{this.hasPrice() && <td style={{ "width": "80px" }}>مبلغ واحد<br /><span style={{ "font-weight": "normal" }} >({this.state.data.global.company.currencyUnit})</span></td>}
														{this.state.data.record.type !== 11 && this.state.data.record.type !== 10 && this.state.data.record.type !== 9 && this.state.data.global.company.enableMultiCurrency === 2 && <td style={{ "width": "90px" }}>ارز</td>}
														{this.state.data.record.type !== 11 && this.state.data.record.type !== 10 && this.state.data.record.type !== 9 && this.state.data.global.company.enableMultiCurrency === 2 && <td style={{ "width": "90px" }}>نرخ ارز</td>}
														{this.state.data.record.type !== 11 && this.state.data.record.type !== 10 && this.state.data.record.type !== 9 && this.state.data.global.company.enableMultiCurrency === 2 && <td style={{ "width": "90px" }}>مبلغ ارزی</td>}

														{this.hasDiscount() && <td style={{ "width": "85px" }}>تخفیف</td>}
														{this.hasDiscount() && <td style={{ "width": "100px" }}>مبلغ<br />بعد از تخفیف</td>}
														{this.hasTax() && <td style={{ "width": "80px" }}>مالیات</td>}
														{(this.state.data.record.type === 14 || this.state.data.record.type === 13 || this.state.data.record.type === 9) && <td style={{ "width": "140px" }}>{(this.state.data.record.type === 14 || this.state.data.record.type === 13) ? "شماره گوشواره" : "حساب"}</td>}

														{this.hasTotal() && <td style={{ "width": "100px" }}>جمع کل <span style={{ "font-weight": "normal" }} >({this.state.data.global.company.currencyUnit})</span></td>}

														{this.hasPaiedPriceCol() && <td style={{ width: '120px' }}>پرداخت شده</td>}
														{this.hasMarketingCol() && <td style={{ width: '120px' }}>معرف</td>}
														{this.hasMarketingCol() && <td style={{ width: '35px' }}>درصد<br />معرف</td>}
														{this.hasMarketingCol() && <td style={{ width: '80px' }}>سهم معرف</td>}

														{this.state.data.global.company.mainBussinessType === 1 && <td style={{ "width": "80px" }}>بیرون بر</td>}
														{this.hasRealInventory() && <td style={{ width: '80px' }}>موجودی فعلی</td>}
														{this.state.data.record.source === 1 && <td style={{ "width": "35px" }}></td>}
													</tr>
												</thead>
												{this.renderBody()}
												{this.state.data.record.type !== 9 && <tfoot style={{ "backgroundColor": "whitesmoke" }}>
													<tr>
														<td className="text-center" colSpan={this.getSumColSpan()}>
															مجموع<br />{this.numberToPersianWords(this.getBodySum('total'))} {this.state.data.global.company.currencyUnit}
														</td>
														{<td className="text-center">{this.FixedPointNumber(this.getBodySum('count'), 3)}</td>}
														<td></td>
														{this.state.data.record.type !== 9 && this.state.data.global.company.stuffSubUnitEnable === 2 && <td className="text-center">{this.FixedPointNumber(this.getBodySum('modulusCount'), 3)}</td>}
														{this.state.data.record.type !== 9 && this.state.data.global.company.stuffSubUnitEnable === 2 && <td></td>}
														{this.state.data.record.type !== 9 && <td className="text-center">{this.getBodySum('price')}</td>}
														{this.state.data.record.type !== 9 && this.state.data.global.company.enableMultiCurrency === 2 && <td></td>}
														{this.state.data.record.type !== 9 && this.state.data.global.company.enableMultiCurrency === 2 && <td></td>}
														{this.state.data.record.type !== 9 && this.state.data.global.company.enableMultiCurrency === 2 && <td className="text-center">{this.getBodySum('price2')}</td>}

														{this.hasDiscount() && <td className="text-center">{this.getBodySum('discount')}</td>}
														{this.hasDiscount() && <td className="text-center">{this.getBodySum('adis')}</td>}
														{this.state.data.record.type !== 9 && this.state.data.record.type !== 5 && <td className="text-center">{this.getBodySum('tax')}</td>}
														{this.state.data.record.type !== 9 && <td className="text-center">{this.getBodySum('total')}</td>}
														{this.state.data.record.source === 1 && <td></td>}
													</tr>
												</tfoot>}
											</table>
										</div>
									</div>
								</div>
								<div className="tab-pane" id="tab2" role="tabpanel">
									{this.renderAdjustments(1)}
								</div>
								<div className="tab-pane" id="tab3" role="tabpanel">
									{this.renderAdjustments(2)}
								</div>
								{this.state.data.record.id !== this.getDefaultGuid() && <div className="tab-pane" id="tab4" role="tabpanel">
									<WorkFlowStepLogging Caller={this} EntityId={this.state.data.record.id} WorkFlowStepId={this.state.data.record.workFlowStepId} Type={1} />
								</div>}
							</div>

							<div className="row" style={{ "padding-left": "15px" }} >
								<div className="col-lg-9 col-md-12 col-sm-12">
									<div className="row">
										<div className="col-md-12 text-right">
											<table className="ng-hide">
												<tbody>
													<tr>
														<td>
															<div className="form-inline ng-pristine ng-valid" style={{ "margin-right": "5px" }} >
																<div className="form-group">
																	<div className="input-group">
																		<div className="input-group-addon hand">
																			%
																		</div>
																		<div>
																			<input onChange={e => this.state.data.record.discountPercent = e.target.value} defaultValue={this.state.data.record.discountPercent} autocomplete="off" onblur="DiscountApply(1)" type="text" className="form-control input-sm ng-valid" placeholder="تخفیف" style={{ "width": "60px" }} /></div>
																	</div>
																</div>
															</div>
														</td>
														<td>
															<div className="form-inline ng-pristine ng-valid" style={{ "margin-right": "5px" }} >
																<div className="form-group">
																	<div className="input-group">
																		<div className="input-group-addon hand">
																			{this.state.data.global.company.currencyUnit}
																		</div>
																		<div>
																			<input onChange={e => this.state.data.record.discount = e.target.value} defaultValue={this.state.data.record.discount} autocomplete="off" onblur="DiscountApply(2)" type="text" className="form-control input-sm ng-valid" placeholder="تخفیف" style={{ "width": "120px" }} /></div>
																	</div>
																</div>
															</div>
														</td>
													</tr>
												</tbody>
											</table>
										</div>
									</div>
									<div className="row mr-t-10">
										<div className="col-md-2 ltr text-right">
										</div>
									</div>
									{this.state.data.record.type !== 9 && <div className="form-group" style={{ "padding-left": "50px" }} >
										<label className="title1" for="comment">یادداشت</label>
										<textarea onChange={e => this.state.data.record.note = e.target.value} defaultValue={this.state.data.record.note} className="form-control ng-pristine ng-untouched ng-valid" rows="4" maxlength="250"></textarea>
									</div>}
								</div>
								{this.state.data.record.type !== 14 && this.state.data.record.type !== 13 && this.state.data.record.type !== 9 && <div className="col-lg-3 col-md-12 col-sm-12" style={{ "padding": "0" }} >
									<div className="row text-left">
										<div className="col-lg-4 title1" style={{ "padding": "0" }} ></div>
										<div className="col-lg-4 text-center title1" style={{ "direction": "ltr" }} >{this.state.data.global.company.currencyUnit}</div>
										{this.state.data.global.company.enableMultiCurrency === 2 && <div className="col-lg-4 text-center title1" style={{ "direction": "ltr" }} ></div>}
									</div>
									<div className="row text-left">
										<div className="col-lg-4 title1" style={{ "padding": "0" }} >مجموع </div>
										<div className="col-lg-4 text-center title1" style={{ "direction": "ltr" }} >{this.money(this.state.data.record.tprdis)}</div>
										{this.state.data.global.company.enableMultiCurrency === 2 && <div className="col-lg-4 text-center title1" style={{ "direction": "ltr" }} >{this.money(this.state.data.record.tprdis2)}</div>}
									</div>
									{this.hasDiscount() && <div className="row text-left">
										<div className="col-lg-4 title1" style={{ "padding": "0" }} >مجموع تخفیفات </div>
										<div className="col-lg-4 text-center title1 red" style={{ "direction": "ltr" }} >({this.money(this.state.data.record.tdis)})</div>
										{this.state.data.global.company.enableMultiCurrency === 2 && <div className="col-lg-4 text-center title1" style={{ "direction": "ltr" }} >{this.money(this.state.data.record.tdis2)}</div>}
									</div>}
									{this.hasTax() && <div className="row text-left">
										<div className="col-lg-4 title1" style={{ "padding": "0" }} >جمع مالیات</div>
										<div className="col-lg-4 text-center title1" style={{ "direction": "ltr" }} >{this.money(this.state.data.record.tvam)}</div>
										{this.state.data.global.company.enableMultiCurrency === 2 && <div className="col-lg-4 text-center title1" style={{ "direction": "ltr" }} >{this.money(this.state.data.record.tvam2)}</div>}
									</div>}
									{this.state.data.record.type !== 5 && <div className="row text-left">
										<div className="col-lg-4 title1" style={{ "padding": "0" }} >تخفیف نهایی </div>
										<div className="col-lg-4 text-center title1 red" style={{ "direction": "ltr" }}>
											<NumberFormat
												value={this.state.data.record.discount}
												onChange={e => this.setFinalDiscount(e)}
												thousandSeparator={true}
												prefix={''}
												className="form-input text-center ltr"
											/>
										</div>
									</div>}
									<div className="row text-left">
										<div className="col-lg-4 title1" style={{ "padding": "0" }} >مجموع عوامل افزاینده </div>
										<div className="col-lg-4 text-center title1 red" style={{ "direction": "ltr" }} >{this.money(this.getAdjustmentSum(1))}</div>
									</div>
									<div className="row text-left">
										<div className="col-lg-4 title1" style={{ "padding": "0" }} >مجموع عوامل کاهنده </div>
										<div className="col-lg-4 text-center title1 red" style={{ "direction": "ltr" }} >({this.money(this.getAdjustmentSum(2))})</div>
									</div>
									<div className="row" style={{ "border-top": "1px solid rgb(69, 69, 69)", "margin-top": "1px", "margin-bottom": "1px" }} ></div>
									<div className="row text-left" style={{ "border-bottom": "1px solid rgb(69, 69, 69)" }} >
										<div className="col-lg-4 h5 txt-bold" style={{ "padding": "0" }}>مبلغ نهایی</div>
										<div className="col-lg-4 h5 text-center txt-bold" style={{ "direction": "ltr" }} >{this.money(this.state.data.record.total)}</div>
										{this.state.data.global.company.enableMultiCurrency === 2 && <div className="col-lg-4 text-center title1" style={{ "direction": "ltr" }} >{this.money(this.state.data.record.total2)}</div>}
									</div>
									<div className="row text-left" style={{ "border-bottom": "1px solid rgb(69, 69, 69)" }} >
										<div className="col-lg-4 h5 txt-bold" style={{ "padding": "0" }}>مانده</div>
										<div className="col-lg-4 h5 text-center txt-bold" style={{ "direction": "ltr" }} >{this.money(this.state.data.record.total - this.state.data.totalReciept)}</div>
										{this.state.data.global.company.enableMultiCurrency === 2 && <div className="col-lg-4 text-center title1" style={{ "direction": "ltr" }} >{this.money(this.state.data.record.total2 - this.state.data.totalReciept2)}</div>}
									</div>
									<div className="row" style={{ "border-top": "1px solid rgb(69, 69, 69)", "margin-top": "1px", "margin-bottom": "10px" }} ></div>
								</div>}
							</div>
						</div>
						<div className="modal-footer">
							{this.state.data.record.status === 2 && (this.state.data.record.documents.length === 0) && <button type="button" className="hand btn btn-primary" onClick={e => this.documentGenerate()} >صدور سند</button>}
							{this.state.data.record.type !== 9 && this.state.data.record.status === 1 && <button type="button" className="hand btn btn-primary" onClick={e => this.save(e, 1)} >ذخیره - پیش نویس</button>}
							{this.state.data.record.type !== 9 && this.state.data.record.status === 1 && this.hasPermission(225) && <button type="button" className="hand btn btn-primary" onClick={e => this.save(e, 2)} >ذخیره - نهایی</button>}
							{this.state.data.record.type === 9 && this.state.data.record.status === 1 && <button type="button" className="hand btn btn-primary" onClick={e => this.save(e, 1)} >ذخیره</button>}
							{this.state.data.record.type === 9 && this.state.data.record.status === 1 && this.hasPermission(225) && <button type="button" className="hand btn btn-primary" onClick={e => this.save(e, 2)} >ذخیره - صدور سند</button>}

							{this.state.data.record.id !== this.defaultGuid() && (this.state.data.record.type === 2 || this.state.data.record.type === 8) &&
								<button type="button" className="btn btn-success" onClick={e => this.reciept(1)}>دریافت</button>
							}
							{this.state.data.record.id !== this.defaultGuid() && (this.state.data.record.type === 1 || this.state.data.record.type === 6 || this.state.data.record.type === 7) &&
								<button type="button" className="btn btn-success" onClick={e => this.reciept(2)}>پرداخت</button>
							}
							{this.state.data.record.id !== this.defaultGuid() && (this.state.data.record.type === 2 || this.state.data.record.type === 8) &&
								<button type="button" className="btn btn-danger" onClick={e => this.makeTaxInvoice()}>صدور صورتحساب مودیان</button>
							}
							&nbsp;
							{this.state.data.record.id !== this.defaultGuid() && <a onClick={e => this.openPrint()} className="btn btn-danger"><span>PDF</span></a>}
							{this.state.data.global.company.id === 'f466ea28-599f-4395-9282-b54b7ff62a90' && this.state.data.record.id !== this.defaultGuid() && (this.state.data.record.type === 2 || this.state.data.record.type === 8) && <a onClick={e => this.onSendPayLink()} className="btn btn-danger"><span>لینک پرداخت</span></a>}
							{this.state.data.record.id !== this.defaultGuid() && <a className="btn btn-danger me-2" onClick={e => this.confirmRemove(this.state.data.record.id, !this.fromOrdering())} >حذف فاکتور</a>}
							{this.state.data.record.type != 5 &&
								<a className="btn btn-warning" onClick={e => this.closeMe()}>انصراف</a>
							}
						</div>
					</div>
				</div>
			</div>
		</div>
	}
	setFinalDiscount(e) {
		this.state.data.record.discount = parseFloat(e.target.value.replace(/,/g, ''));
		this.updateFormula();
	}
	render() {
		if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

		let contents = this.state.loading ? this.renderLoading() :
			[
				this.state.lockScreen === 1 && this.lockScreen(),
				this.getGlobalContainer(),
				this.state.data.status === 0 ? this.apiFailInModal() : this.renderForm(),
				this.renderPopupComponent()
			];

		return contents;
	}
}